import React from 'react'
import IconButton from '@/components/ui/Buttons/IconButton'
import { ReactComponent as SettingsIcon } from '@/assets/icons/cogs.svg'

export type SettingsButtonProps = { onClick?: () => void; title?: string }

const Settingsbutton = ({ onClick, title = 'Route settings' }: SettingsButtonProps) => {
  return (
    <IconButton
      onClick={onClick}
      color={'neutral'}
      data-tooltip-id="tooltip"
      data-tooltip-content={title}
      data-tooltip-delay-show={600}
    >
      <SettingsIcon />
    </IconButton>
  )
}

export default Settingsbutton
